import type { IServiceDataItem } from './getServiceData';

export function getServiceDataForEpisodeRadiology(): Partial<IServiceDataItem> {
    return {
        costs: 'eigen risicovrij (m.u.v. DSW)',
        steps: [
            'Upload de echografiebeelden',
            'Vul de informatie van de patiënt in en stel je vraag aan de radioloog',
            'Je ontvangt het antwoord via Edifact (in je HIS)',
            'Stel een extra vraag aan de radioloog als dat nodig is',
        ],
        subTitle: (
            <>
                Voor advies over <strong>de interpretatie van een echografieonderzoek en het te volgen beleid</strong>
            </>
        ),
        title: 'Consult Echografie',
        waitingTime: 'binnen 2 werkdagen',
    };
}
